const config = {
  development: "https://s3.amazonaws.com/images.primeagile.com",
  production: "https://images.primeagile.com",
  // API_URL : 'https://api.stage.primeagile.com/2021-11-11'''
  API_URL: "https://api.stage.primeagile.com/2022-05-31",
}
module.exports = config;


